export default __webpack_public_path__ + "static/media/3.VERIFICACION_CAPSULAS_WEB_SFS.2cba5be6.mp4";